import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-bidirectional-selection',
    templateUrl: './bidirectional-selection.component.html',
    styleUrls: ['./bidirectional-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BidirectionalSelectionComponent implements OnInit {
  @Input() currentSegment: 'import' | 'export' = 'export';
  @Input() rewardList: any[] = [];
  @Output() sendRewardList = new EventEmitter<any[]>();

  filteredRewards: any[] = [];
  selectedRewards: any[] = [];
  searchInputValue = '';

  ngOnInit(): void {
    this.filteredRewards = this.rewardList || [];
  }

  filterSearchReward(): void {
    if (!this.searchInputValue) {
      this.filteredRewards = this.rewardList;
      return;
    }
    const value = this.searchInputValue.toLowerCase().trim();
    this.filteredRewards = this.rewardList.filter((reward) => (reward.name || '').toLowerCase().includes(value));
  }

  checkboxToggleReward(reward: any): void {
    const exists = this.selectedRewards.some((value) => value.id === reward.id);
    if (exists) {
      this.selectedRewards = this.selectedRewards.filter((value) => value.id !== reward.id);
      if (!this.rewardList.some((value) => value.id === reward.id)) {
        this.rewardList.unshift(reward);
      }
      this.filteredRewards = this.rewardList;
    } else {
      this.selectedRewards.unshift(reward);
      const rewardIndex = this.rewardList.findIndex((value) => value.id === reward.id);
      if (rewardIndex !== -1) {
        this.rewardList.splice(rewardIndex, 1);
      }
      this.filteredRewards = this.rewardList;
      this.searchInputValue = '';
    }
  }

  sendSelectedRewards(): void {
    this.sendRewardList.emit(this.currentSegment === 'export' ? this.selectedRewards : this.filteredRewards);
  }

  exportAll(): void {
    this.selectedRewards = this.selectedRewards.concat(this.filteredRewards);
    this.filteredRewards = [];
    this.rewardList = [];
  }
}
